import styled from 'styled-components';
var Content = styled.p.withConfig({
  displayName: "Contentstyles__Content",
  componentId: "fgrrfp-0"
})(["ul{margin:10px 20px;li{list-style-type:disc;}}"]);
var Variants = styled.div.withConfig({
  displayName: "Contentstyles__Variants",
  componentId: "fgrrfp-1"
})(["margin-bottom:15px;"]);
var SalePrice = styled.span.withConfig({
  displayName: "Contentstyles__SalePrice",
  componentId: "fgrrfp-2"
})(["color:", ";margin-right:5px;font-size:", ";"], function (props) {
  return props.theme.color.palette.red;
}, function (props) {
  return props.theme.font.size.base;
});
var WasPrice = styled.span.withConfig({
  displayName: "Contentstyles__WasPrice",
  componentId: "fgrrfp-3"
})(["color:", ";font-size:", ";text-decoration:line-through;"], function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.theme.font.size.base;
});
export { Content, Variants, SalePrice, WasPrice };